import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/components/Landing";
import Checkout from "@/components/Checkout";
import Terms from "@/components/Terms";
import Refund from "@/components/Refund";
import Privacy from "@/components/Privacy";
import AdminDashboard from "@/components/AdminDashboard";
import Security from "@/components/Security";

function App() {
  useEffect(() => {
    document.title = "Radio App Consultancy — Radio, App & Software Consultancy";
  }, []);

  return (
    <div className="App" data-testid="app-root">
      <Toaster
        position="top-center"
        theme="light"
        toastOptions={{
          style: {
            background: "#FFFFFF",
            border: "1px solid #E6E8F0",
            color: "#0F172A",
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/pay" element={<Checkout />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/refund" element={<Refund />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/security" element={<Security />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
